import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import LegalBanner from "@/components/LegalBanner";
import Footer from "@/components/Footer";
import ContactSection from "@/components/home/ContactSection";
import { Seo } from "@/lib/seo";

export default function Support() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-white text-stone-900 font-sans antialiased" data-testid="support-page">
      <Seo
        title="Support | DriveClear"
        description="Get help with DriveClear — contact our support team, browse common questions, or review our policies."
        path="/support"
      />
      <LegalBanner />
      <Header />
      <main>
        <section className="py-14 lg:py-16 bg-[#faf9f7] border-b border-stone-100">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight mb-4">DriveClear Support</h1>
            <p className="text-stone-600 text-base leading-relaxed mb-6">
              We're here to help with the DriveClear app and website — account questions, calculator feedback, subscription help, or anything else. We respond within 1 business day.
            </p>
            <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm">
              <a href="mailto:customersupport@driveclearapp.com" data-testid="support-email-link" className="font-semibold text-blue-700 hover:text-blue-800">
                customersupport@driveclearapp.com
              </a>
              <Link to="/privacy" data-testid="support-privacy-link" className="font-semibold text-stone-600 hover:text-stone-900">Privacy Policy</Link>
              <Link to="/terms" data-testid="support-terms-link" className="font-semibold text-stone-600 hover:text-stone-900">Terms of Service</Link>
            </div>
          </div>
        </section>
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
